/** Person name from ERP cliente (nombres + apellidos). */
export const erpClientPersonName = (cliente) =>
  [cliente?.nombres, cliente?.apellidos].filter(Boolean).join(" ");

/**
 * Primary label for ERP cliente in CRM (chat header, dialogs, lists).
 * Prefers negocio when registered; otherwise nombres + apellidos.
 */
export const erpClientDisplayName = (cliente) => {
  const negocio =
    cliente?.negocio != null ? String(cliente.negocio).trim() : "";
  if (negocio) return negocio;
  return erpClientPersonName(cliente);
};

export default erpClientDisplayName;
